<template>
  <div class="step step--clean-air-opening clean-air-opening cleaning" v-if="step === 'clean-air-opening'">
    <div class="clean-air-opening__title text-shadow" v-html="$t('cleaningAir.title')"></div>
    <div class="clean-air-opening__text" v-html="$t('cleaningAir.title2')"></div>

    <div class="conditioning__controls clean-air-opening__controls">
      <div class="conditioning__image clean-air-opening__image">
        <img src="@/assets/img/streamer.png" alt="streamer purifier">
      </div>

      <div class="conditioning__control clean-air-opening__control">
        <img class="image-rendering-contrast" src="@/assets/img/modes/streamer.png" alt="streamer mode">
      </div>
    </div>

    <Button classes="button--small" @click="cleanAir()" v-html="$t('cleaningAir.button')"></Button>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import Button from '@/components/global/Button'
import isIOS from '../../helpers/isIOS'

export default {
  name: 'StepCleaningAir',
  props: {},

  components: {
    Button
  },

  data() {
    return {

    }
  },

  mounted () {
    if(!isIOS()) {
      this.$store.commit('setModel', 5)
    }

    this.$store.commit('setClouds', 2)

    if (this.$gtm) {
      this.$gtm.trackEvent({
        'event': 'Event',
        'analytics_action': this.$store.state.step + '-mounted',
        'analytics_label': this.$store.state.step,
      })
    }
  },

  created () {},

  updated () {},

  methods: {
    cleanAir() {
      if (this.$gtm) {
        this.$gtm.trackEvent({
          'event': 'Event',
          'analytics_action': this.$store.state.step + '-button-clean-air',
          'analytics_label': this.$store.state.step,
        })
      }

      this.next()
    },

    next () {
      this.$store.commit('setStep', 'clean-air-interactive')
    },
  },

  watch: {},

  computed: {
    ...mapState({
      step: state => state.step
    })
  }
}
</script>

<style lang="scss" scoped>

</style>
